'use strict';

var styled = require('styled-components');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var styled__default = /*#__PURE__*/_interopDefaultCompat(styled);

const Container = styled__default.default.div `
  box-sizing: border-box;
  border-bottom: ${({ theme }) => theme.designTokens.headerNavBarBorderBottom};
  padding: 0 ${({ theme }) => theme.designTokens.headerNavBarPaddingX};
  height: 4.5rem;
  display: flex;
  align-items: center;
  position: sticky;
  top: 0;
  > * {
    flex: 1;
  }
`;
const TabContainer = styled__default.default.div `
  display: flex;
  align-items: center;
  justify-content: center;
`;
const LogoContainer = styled__default.default.div `
  font-size: ${({ theme }) => theme.designTokens.headerNavBarLogoFontSize};
  & svg {
    display: block;
  }
`;
const Burger = styled__default.default.div `
  cursor: pointer;
  padding: ${({ theme }) => theme.designTokens.headerNavBarBurgerPaddingY}
    ${({ theme }) => theme.designTokens.headerNavBarBurgerPaddingX};
`;
const Styled = {
    Container,
    Burger,
    LogoContainer,
    TabContainer,
};

exports.Styled = Styled;
//# sourceMappingURL=styles.js.map
